import axios, { AxiosResponse } from 'axios';

export interface IDatumVypisu {
    stav: 'LZE' | 'NELZE';
}

export interface IDatumUhrady {
    datuhr: string;
}

export interface IDatumUhradyKontrola {
    stav: boolean;
}

/* Vrátí seznam kódů účastníka */
export const ueDatumvypisu = (datum: string, mena?: string) => {
    return axios({
        method: 'GET',
        url: '/UE/datumupisu',
        params: {
            datum: datum,
            ...(mena && {
                mena: mena
            })
        }
    }).then((resp: AxiosResponse<IDatumVypisu>) => resp.data);
};
export const ueDatumuhrady = (datum: string) => {
    return axios({
        method: 'GET',
        url: '/UED/datuhrmax',
        params: {
            datumupisu: datum
        }
    }).then((resp: AxiosResponse<IDatumUhrady>) => resp.data);
};
export const ueDatumuhradyKontrola = (datumUpisu: string, nazazsiDatum: string) => {
    return axios({
        method: 'GET',
        url: '/UED/datuhrkontr',
        params: {
            datumupisu: datumUpisu,
            datuhr: nazazsiDatum
        }
    }).then((resp: AxiosResponse<IDatumUhradyKontrola>) => resp.data);
};
